export const baseURL = 'https://techcrunch.com/wp-json/wp/v2';